import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { UnespCoreEnvironment, UnespCoreGenericService, UnespCoreMessageService } from '@unesp/core';
import { Observable } from 'rxjs';
import { CandidatoModel } from 'src/app/models/candidato.model';
import { DadosCandidatoModel } from 'src/app/models/dados-candidato.model';



@Injectable({
  providedIn: 'root'
})
export class CandidatoService extends UnespCoreGenericService{


  readonly ROUTE = 'candidato';
  client!: HttpClient

  constructor(
    http: HttpClient,
    @Inject('environment') protected environment: UnespCoreEnvironment,
    private messageService: UnespCoreMessageService,

) {
    super(http, environment);
    this.client = http
   }

  habilitar(dados: DadosCandidatoModel): Observable<any>{
    return this.create<DadosCandidatoModel>(`${this.ROUTE}/habilitar`, dados);
  }

  getCandidatoAtivo() : Observable<CandidatoModel>{
    return this.client.get<CandidatoModel>(`${this.ENDPOINT}/${this.ROUTE}/me`)
  }

  isCandidatoInativo(): Observable<boolean> {
    return this.client.get<boolean>(`${this.ENDPOINT}/${this.ROUTE}/inativo`)
  }



}
